import React, { createContext, useEffect, useMemo, useReducer } from 'react'
import { columns as getDxColumns } from '../dxColumns/dxColumns'
import { useTranslation } from 'react-i18next'
import useLocale from '../../../../../hooks/useLocale'
import { filterReducer } from '../../filterFragments'
import moment from 'moment'
import { useStatisticsData } from '../../helpers'
import { getShopStatisticsData, initShopStatistics } from '../../../gql/getShopStatistics'
import { generateDynamicHeaders } from '../../../utils'
export const StatisticShopContext = createContext()

export default function StatisticShopProvider({ children }) {
	const [t] = useTranslation()
	const locales = useLocale()
	const statisticsDataReceived = useStatisticsData({
		getQuery: getShopStatisticsData,
		initQuery: initShopStatistics
	})
	const { data = [], loading } = statisticsDataReceived
	const initialColumns = useMemo(() => getDxColumns({ t }), [locales])
	const groupsColumns = useMemo(() => generateDynamicHeaders(data, 'salesGroups'), [loading])
	const [customData, dispatchCustomData] = useReducer(filterReducer, {
		newData: [],
		newDataColumns: initialColumns,
		articleGroups: false,
		savedSettings: {},
		profiles: [],
		value: null
	})
	useEffect(() => {
		if(customData.articleGroups && initialColumns.length !== customData.newDataColumns) {
			dispatchCustomData({ type: 'newDataColumns', value: [...initialColumns, ...groupsColumns] })
		}
		dispatchCustomData({ type: 'newData', value: data })
	}, [loading])
	useEffect(() => {
		if(customData.articleGroups && initialColumns.length !== customData.newDataColumns) {
			dispatchCustomData({ type: 'newDataColumns', value: [...initialColumns, ...groupsColumns] })
			return
		}
		dispatchCustomData({ type: 'newDataColumns', value: initialColumns })
	}, [customData.articleGroups])

	const [filterPrepare, dispatchFilter] = useReducer(filterReducer, {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),
		groupBy: 'SHOP'
	})
	return (<>
		<StatisticShopContext.Provider value={{ filterPrepare, dispatchFilter, customData, dispatchCustomData, statisticsDataReceived }}>
			{children}
		</StatisticShopContext.Provider>
	</>)
}
